export class OptionModel {
  text: string;
  id: any;
  checked = false;
  disabled: boolean;
  tooltip: string;
  name: string;
  isShowNotifyStatements: boolean;

  constructor(
    text: string,
    id: any,
    checked = false,
    disabled: boolean = false,
    tooltip: string = '',
    isShowNotifyStatements: boolean = false,
  ) {
    this.text = text;
    this.id = id;
    this.checked = checked;
    this.disabled = disabled;
    this.tooltip = tooltip;
    this.name = text;
    this.isShowNotifyStatements = isShowNotifyStatements;
  }
}
export class TagOptionModel extends OptionModel {
  chemicalSubstanceEntityId: string;
  dangerSourceAttributeCode: string;
  locationId: string;
  code: string;

  constructor(
    text: string,
    id?: string,
    checked = false,
    disabled?: boolean,
    chemicalSubstanceEntityId: string = '',
    dangerSourceAttributeCode: string = '',
    locationId: string = '',
    code: string = '',
  ) {
    super(text, id, checked, disabled);
    this.chemicalSubstanceEntityId = chemicalSubstanceEntityId;
    this.dangerSourceAttributeCode = dangerSourceAttributeCode;
    this.locationId = locationId;
    this.code = code;
  }
}
export class UserOptionModel extends OptionModel {
  email: string;
  userCanPerformWorkAssignment = true;
  userHaveLocationPermission = true;
  constructor(text: string, id: any, checked = false, disabled?: boolean, email?: string) {
    super(text, id, checked, disabled);
    this.email = email || '';
  }
}

export class WorkAssignmentTypeOptionModel extends OptionModel {
  note: string;

  constructor(text: string, id: any, checked = false, disabled?: boolean, note?: string) {
    super(text, id, checked, disabled);
    this.note = note || '';
  }
}

export class LocationSubstanceOptionModel extends OptionModel {
  chemicalSubstanceId: string;

  constructor(text: string, locationId: string, chemicalSubstanceId: string) {
    super(text, locationId, false, false);
    this.chemicalSubstanceId = chemicalSubstanceId;
  }
}

export class StatusOptionModel extends OptionModel {
  statusEN: string;
  statusNO: string;

  constructor(text: string, id: number, statusEN: string, statusNO: string) {
    super(text, id);
    this.statusEN = statusEN;
    this.statusNO = statusNO;
  }
}

export class RequestBindingOptionModel extends OptionModel {
  fieldName: string;

  constructor(text: string, id: number, tooltip: string, fieldName: string) {
    super(text, id, false, false, tooltip);
    this.fieldName = fieldName;
  }
}

export class TreeCommonModel {
  id: string;
  name: string;
  constructor(id: string, name: string) {
    this.id = id;
    this.name = name;
  }
}
